<template>
	<div>
		<div class="p-layout-breadcrumb">
			<el-row type="flex" align="middle">
				<el-col :span="3">
					<h3>轮播banner管理</h3>
				</el-col>
				<el-col :span="2">
					<el-button type="info" @click="handleAdd">新建</el-button>
				</el-col>
			</el-row>
		</div>
		<el-table :data="fetchList" :default-sort = "{prop: 'type', prop: 'targetName'}">
			<el-table-column inline-template :context="_self" label="图片" width="180">
				<img :src="row.picUrl" class="user-pic" />
			</el-table-column>
			<el-table-column inline-template :context="_self" label="跳转类型" width="180" prop="type" sortable>
				<div>
					<span v-if="row.type === 0">
					            分类
					          </span>
					<span v-else-if="row.type === 1">
					            标签
					        </span>
					<span v-else>
								商品
							</span>
				</div>
			</el-table-column>
			<el-table-column prop="targetName" label="名称" sortable>
			</el-table-column>
			<el-table-column inline-template :context="_self" width="150" label="操作">
				<span>
					                  <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
					                  <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
					        </span>
			</el-table-column>
		</el-table>
	
		<div class="page-footer">
			<el-button type="primary" @click="next" size="large">下一步</el-button>
		</div>
	
	</div>
</template>

<script>
	import {
		getVersions,
		getGlobalSettings,
		filterIndexVersions,
		getProductCategories,
		getProductTags,
		getProductDetails,
		getProductDetailsOnly
	} from '../../api/version'
	
	export default {
		data() {
			return {
				Role: sessionStorage.power,
				fetchList: [],
				global: [],
				userRules: {
					user: [{
						max: 10,
						messasge: '最大长度是 10 个字符'
					}]
				},
				userForm: {
					user: '1',
					role: ''
				},
				editFormVisible: false,
				editForm: {
					username: '',
					address: ''
				},
				addBanner: false,
				versionForm: {
					version: '',
					base: '',
					remark: ''
				},
				versionOption: [],
				imageUrl: '',
				uptoken: {
					token: sessionStorage.token
				},
				topicArr: [],
				productArr: [],
				categoryArr: []
			}
		},
		created() {
			let cate = getProductCategories().then(res => {
				this.categoryArr = res.data
				this.$store.commit('SETCATEGORYARR', this.categoryArr);
			})
	
			let tag = getProductTags().then(res => {
				this.topicArr = res.data
				this.$store.commit('SETPRODUCTARR', this.topicArr);
			})
	
			let pro =  getProductDetailsOnly(sessionStorage.userId,JSON.stringify({where:{accessoryType: 0}})).then(res => {
				this.productArr = res.data
				this.$store.commit('SETTOPICARR', this.productArr);
			})
	
			Promise.all([cate, tag, pro]).then(val => {
				let currentData = this.$store.state.currentIndex
				let bannerData = []
	
				bannerData = JSON.parse(JSON.stringify(currentData.value.banner))
				bannerData.forEach((item, index) => {
					if (item.type === 0) {
						this.categoryArr.forEach(item2 => {
							if (item2.categoryId === item.targetId) {
								item.targetName = item2.name
							}
						})
					} else if (item.type === 1) {
						this.topicArr.forEach(item2 => {
							if (item2.tagId === item.targetId) {
								item.targetName = item2.name
							}
						})
					} else {
						this.productArr.forEach(item2 => {
							if (item2.productDetailId === item.targetId) {
								item.targetName = item2.name
							}
						})
					}
				})
				this.fetchList = bannerData
				console.log(this.fetchList,'fetch')
	
			})
	
			getGlobalSettings().then(res => {
				this.global = res.data
				console.log(res)
			})
	
			filterIndexVersions().then(res => {
				this.versionOption = res.data
				console.log(res, 'hh')
			})
		},
		methods: {
			handleEdit(index, row) {
				this.$router.push('/editBanner/' + row.targetId)
			},
			handleAdd() {
				this.$router.push('/addbanner')
			},
			next() {
				let currentData = this.$store.state.currentIndex
				if (currentData.value.banner.length) {
					this.$router.push('/indexTopic')
				} else {
					this.$message({
						message: '请先添加轮播banner',
						type: 'warning'
					});
				}
	
			},
			handleDelete(index, row) {
					this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.fetchList.forEach( (item,index) => {
							if(item.picUrl === row.picUrl) {
								this.fetchList.splice(index, 1)
							}
						})
						
						let currentBanner = JSON.parse(JSON.stringify(this.fetchList))
						let currentData = this.$store.state.currentIndex
						currentBanner.forEach( item => {
							delete item.targetName
						})
						currentData.value.banner = currentBanner
						this.$store.commit('SETCURRENTINDEX', currentData);
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						// this.refresh()
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				
			},
			handleCheck(val) {},
			refresh() {
				this.$refs.user.refresh()
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				this.uptoken = {
					token: sessionStorage.token
				}
	
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			}
		}
	}
</script>

<style>
	.user-pic {
		width: 50px;
		height: 50px;
		margin-top: 10px;
	}
	
	.avatar-uploader .el-upload {
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.page-footer {
		margin-top: 60px;
		text-align: center;
	}
</style>




// WEBPACK FOOTER //
// IndexBanner.vue?66fb2af6